import { GET_TOUR_ITEMS } from '@package/constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * Tour item Reducer
 * @param {*} state
 * @param {*} action
 */
export default function tourItem(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_TOUR_ITEMS}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${GET_TOUR_ITEMS}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        result: action?.result,
      };
    case `${GET_TOUR_ITEMS}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
